import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../../lib/api";

export default function AdminFuel() {
  const [f, setF] = useState(null);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => { api.get("/fuel-prices").then((r) => setF(r.data)); }, []);

  if (!f) return <div>Loading…</div>;

  const save = async () => {
    setErr(""); setMsg("");
    try {
      const { data } = await api.put("/fuel-prices", f);
      setF(data);
      setMsg("Saved.");
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
  };

  const upd = (k) => (e) => setF({ ...f, [k]: parseFloat(e.target.value) || 0 });

  return (
    <div data-testid="admin-fuel">
      <div className="section-label">Pricing</div>
      <h1 className="font-display font-bold text-3xl text-slate-950 mt-2">Fuel Prices</h1>

      <div className="mt-8 bg-white border border-slate-200 p-8 max-w-2xl rounded-md grid sm:grid-cols-2 gap-4">
        <Field label="100LL ($/gal)" value={f.avgas_100ll} onChange={upd("avgas_100ll")} tid="fuel-100ll" />
        <Field label="Jet-A w/ Prist ($/gal)" value={f.jet_a_with_prist} onChange={upd("jet_a_with_prist")} tid="fuel-jeta-prist" />
        <Field label="Self-Serve Discount ($/gal)" value={f.self_serve_discount} onChange={upd("self_serve_discount")} tid="fuel-discount" />
        <div className="sm:col-span-2">
          <label className="text-sm font-medium text-slate-900 mb-1 block">Notes</label>
          <textarea
            data-testid="fuel-notes"
            className="w-full border border-slate-300 px-3 py-2 focus:border-slate-950 outline-none"
            value={f.notes || ""}
            onChange={(e) => setF({ ...f, notes: e.target.value })}
            rows={3}
          />
        </div>
        <div className="sm:col-span-2 flex items-center gap-3">
          <button data-testid="fuel-save" onClick={save} className="bg-slate-950 text-white px-6 py-3 font-semibold hover:bg-slate-800">
            Save changes
          </button>
          {msg && <span className="text-emerald-600 text-sm">{msg}</span>}
          {err && <span className="text-red-600 text-sm">{err}</span>}
        </div>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, tid }) {
  return (
    <div>
      <label className="text-sm font-medium text-slate-900 mb-1 block">{label}</label>
      <input
        data-testid={tid}
        type="number"
        step="0.01"
        value={value}
        onChange={onChange}
        className="w-full border border-slate-300 px-3 py-2 focus:border-slate-950 outline-none"
      />
    </div>
  );
}
